export const MakeAvatar = ({ size }) => {
    return `padding: 0;
          margin: 0;
          border-radius: 100%;
          width: ${size || '44'}px;
          height: ${size || '44'}px;

          & > img {
            display: block;
            height: 100%;
            min-width: 100%;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
          }`;
};
